export const CHECKOUT_URL = 'https://trtbp-en.impultienda.ar/checkout/';

export const images = {
  mockup: 'https://cdn.magicpatterns.com/uploads/xyVLz5XH3iswQVgLWh5wx3/MOCKUP_TRTBP-EN.png',
  author: 'https://cdn.magicpatterns.com/uploads/sh5BzoSh2i4NVySd6v6h9R/Dr._James_Whitmore_-_TRT.png',
};
